export default __webpack_public_path__ + "static/imda2019meritaward2-5a44a5ec6dfe8af20c024439b0cda09b.jpg";